import { CanPurchaseDomainSuiteErrors, CheckDomainIsTakenErrors } from '../../typing';
import { parseDomain } from '../../utils';
export const canPurchaseDomainSuite = async _ref => {
  let {
    httpClient,
    request: {
      domain
    }
  } = _ref;
  if (!domain) {
    return {
      canPurchase: false
    };
  }
  const {
    checkDomainIsTaken
  } = (await import('../ApiClients/DomainsApiClient')).DomainsApiClient.queries({
    httpClient
  });
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const [{
    isAvailable,
    premium,
    error
  }] = await Promise.all([checkDomainIsTaken({
    domain: parsedDomain.asciiDomain
  })]);
  let purchaseError;
  switch (error) {
    case CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD:
      purchaseError = CanPurchaseDomainSuiteErrors.NOT_SUPPORTED_TLD;
      break;
    case CheckDomainIsTakenErrors.NOT_SUPPORTED_TLD_REGIONAL:
      purchaseError = CanPurchaseDomainSuiteErrors.NOT_SUPPORTED_TLD_REGIONAL;
      break;
    default:
      purchaseError = undefined;
      break;
  }
  if (!isAvailable) {
    return {
      error: purchaseError,
      canPurchase: false,
      premium
    };
  }
  return {
    canPurchase: true,
    premium
  };
};
//# sourceMappingURL=canPurchaseDomainSuite.js.map